<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"

    :headers="headers"
    item-key="_id"
  >
    <template v-slot:item.name="{ item }">
      <v-tooltip bottom content-class="grey darken-4">
        <template v-slot:activator="{ on: tooltipEvents, attrs: tooltipAttrs }">
          <div
            v-on="tooltipEvents"
            v-bind="tooltipAttrs"
            class="text-truncate"
            style="max-width: 220px"
          >
            <router-link class="text--primary" :to="getFundLink(item)">
              {{ item.name }}
            </router-link>
          </div>
        </template>

        <template v-slot:default>
          {{ item.name }}
        </template>
      </v-tooltip>
    </template>

    <template v-slot:item.quantity="{ item }">
      <span :class="{ 'error--text': item.quantity < 0 }">
        {{ formatNumber(item.quantity) }}
      </span>
    </template>

    <template v-slot:item.unitaryPrice="{ item }">
      {{ formatNumber(item.unitaryPrice) }}
    </template>

    <template v-slot:item.value="{ item }">
      <span :class="{ 'error--text': item.value < 0 }">
        {{ formatCurrency(item.value) }}
      </span>
    </template>

    <template v-slot:item.mtd="{ item }">
      <span :class="{ 'error--text': item.mtd < 0 }">
        {{ formatPerformance(item.mtd) }}
      </span>
    </template>

    <template v-slot:item.ytd="{ item }">
      <span :class="{ 'error--text': item.ytd < 0 }">
        {{ formatPerformance(item.ytd) }}
      </span>
    </template>

    <template v-slot:item.percValue="{ item }">
      <span :class="{ 'error--text': item.percValue < 0 }">
        {{ formatPercentage(item.percValue) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
import { loyallFunds } from '@/config';
import { formatCurrency, formatNumber, formatPercentage } from '@/utils/format-utils';

const EXTERNAL_ONLY_HEADERS = [
  'quantity',
  'unitaryPrice',
  'value',
];

export default {
  name: 'HoldingFundsTable',

  inheritAttrs: false,

  props: {
    meta: {
      type: Object,
      default: () => ({
        isLoyallFund: false,
        refDate: '',
      }),
    },
  },

  data: () => ({
    rawHeaders: [
      {
        value: 'name',
        text: 'Fundo',
      },

      {
        value: 'serial',
        text: 'CNPJ',
      },

      {
        value: 'book',
        text: 'Book',
      },

      {
        value: 'quantity',
        text: 'Quantidade de Cotas',
        align: 'end',
      },

      {
        value: 'unitaryPrice',
        text: 'Valor da Cota',
        align: 'end',
      },

      {
        value: 'value',
        text: 'Valor de Mercado',
        align: 'end',
      },

      {
        value: 'mtd',
        text: 'MTD',
        align: 'end',
      },

      {
        value: 'ytd',
        text: 'YTD',
        align: 'end',
      },

      {
        value: 'percValue',
        text: '%PL',
        align: 'end',
      },
    ],
  }),

  computed: {
    loyallHeaders: (vm) => vm.rawHeaders.filter(
      (item) => !EXTERNAL_ONLY_HEADERS.includes(item.value),
    ),
    headers: (vm) => (vm.meta.isLoyallFund ? vm.loyallHeaders : vm.rawHeaders),
  },

  methods: {
    formatCurrency,
    formatNumber,
    formatPercentage,
    formatPerformance: (val) => formatPercentage(val, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),

    getFundLink(item) {
      const houseFundObj = loyallFunds.find((fund) => fund.serial === item.serial);

      if (!houseFundObj) {
        return `/funds/${item.fundId}`;
      }

      return `/holdings/${houseFundObj.houseFundId}?refDate=${this.meta.refDate}`;
    },
  },
};
</script>
